<template>
  <q-field>
    <q-input type="text"
      v-model="valueModel"
      :disable="disable"
      :float-label="label">
    </q-input>
  </q-field>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    inputType: {
      type: String,
      default: 'string',
    },
    validations: {
      type: Array,
    },
  },

  data() {
    return {
      validationError: false,
    };
  },

  methods: {
    validateField() {
    },
  },

  computed: {
    valueModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

};
</script>
